exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "td, th {\n  padding: 5px; }\n\ntable {\n  margin: auto;\n  background: white; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/invoice/invoice.component.css
// module id = 365
// module chunks = 2